import type { SupportedLanguage } from '@core/i18n/types';
import type { BeveragePairing } from '../types/pairings';

export function getActivePairings(
  pairings: readonly BeveragePairing[] | null | undefined,
): BeveragePairing[] {
  if (!pairings) return [];
  return pairings.filter((p) => p.isActive !== false);
}

export function resolvePairing(
  pairing: BeveragePairing,
  language: string,
): BeveragePairing {
  const tr = pairing.translations?.[language as SupportedLanguage];
  const trName = tr?.name?.trim() ? tr.name : null;
  const trDescription = tr?.description?.trim() ? tr.description : null;
  return {
    ...pairing,
    name: trName ?? pairing.name,
    description: trDescription ?? pairing.description,
  };
}

export function resolvePairingName(
  id: number,
  fallbackName: string,
  beveragePairings: readonly BeveragePairing[] | null | undefined,
  language: string,
): string {
  const source = beveragePairings?.find((p) => p.id === id);
  if (!source) return fallbackName;
  return resolvePairing(source, language).name;
}
